import {createFileRoute, redirect} from "@tanstack/react-router";
import type {ProfileStatus} from "~/routes/_withAuthenticationStatus/_authenticated/_withProfileStatus/-types";
import {ErrorComponent} from "./-errorComponent";
import {NotFoundComponent} from "./-notFoundComponent";
import {PendingComponent} from "./-pendingComponent";
import {RouteComponent} from "./-routeComponent";
import {isCompletePlatformUser} from "~/domainModels/platformUser";
import {getUserProfileDetailsWithCaching} from "~/utilities/queries";

export const Route = createFileRoute("/_withAuthenticationStatus/_authenticated/_withProfileStatus")({
    beforeLoad: async ({context, location}) => {
        const userProfileDetailsResult = await getUserProfileDetailsWithCaching({
            accessToken: context.authenticationStatus.accessToken,
            queryClient: context.queryClient,
            intellsysBaseUrl: context.intellsysBaseUrl,
        });
        if (userProfileDetailsResult.success === false) {
            throw userProfileDetailsResult.error;
        }
        const rawPlatformUser = userProfileDetailsResult.data;

        if (rawPlatformUser === null || !isCompletePlatformUser(rawPlatformUser)) {
            const profileStatus: ProfileStatus = {
                isProfileCompleted: false,
                platformUser: null,
            };
            return {profileStatus: profileStatus};
        }

        const profileStatus: ProfileStatus = {
            isProfileCompleted: true,
            platformUser: rawPlatformUser,
        };
        return {
            profileStatus: profileStatus,
            //
        };
    },
    loader: async () => {},
    staleTime: Infinity,
    component: RouteComponent,
    errorComponent: ErrorComponent,
    pendingComponent: PendingComponent,
    notFoundComponent: NotFoundComponent,
});
